import React from "react";
import { Switch, Redirect } from "react-router-dom";
import {
  ManageFeeHomePage,
  ManageSpecification,
  CreateSpecificationInformation,
  ScheduleRun,
  FeeRun,
  FeeRunParticipantDetails,
  FeeRunDetails,
} from "../layouts";
import { ApplicationRoute, MANAGE_FEE_ROUTES, ROUTES } from "../utils";
import {
  CalculationContainer,
  CreateFeeContainer,
  SummaryContainer,
} from "../containers";
import ApplicableTo from "../layouts/Fee/ApplicableTo/ApplicableTo";
import ManageFeeRun from "../layouts/Fee/ManageFeeRun";
const menu = "fee";
const flow = "edit";
export const ManageFeeRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[MANAGE_FEE_ROUTES.MANAGE_FEE]}
        component={ManageFeeHomePage}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_FEE_ROUTES.APPLICABLE_TO}/:feeId?`,
          `${MANAGE_FEE_ROUTES.APPLICABLE_TO}/:flow(add|edit|save)/:feeId?`,
        ]}
        component={ApplicableTo}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[MANAGE_FEE_ROUTES.SPECIFICATION_INFORMATION]}
        component={ManageSpecification}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[MANAGE_FEE_ROUTES.FEE_RUN]}
        component={ManageFeeRun}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          MANAGE_FEE_ROUTES.CREATE_SPECIFICATION_INFORMATION,
          `${MANAGE_FEE_ROUTES.CREATE_SPECIFICATION_INFORMATION}/:specificationId?`,
          `${MANAGE_FEE_ROUTES.CREATE_SPECIFICATION_INFORMATION}/:flow/:specificationId?`,
        ]}
        component={CreateSpecificationInformation}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          MANAGE_FEE_ROUTES.FEE_RUN_DETAILS,
          `${MANAGE_FEE_ROUTES.FEE_RUN_DETAILS}/:feeTransactionId?`,
          `${MANAGE_FEE_ROUTES.FEE_RUN_DETAILS}/:flow(edit)/:feeTransactionId?`,
        ]}
        component={FeeRunDetails}
      />

      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_FEE_ROUTES.BASIC_DETAILS}/:feeId?`,
          `${MANAGE_FEE_ROUTES.BASIC_DETAILS}/:flow(add|edit|save)/:feeId?`,
        ]}
        component={CreateFeeContainer}
      />

      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          MANAGE_FEE_ROUTES.SUMMARY,
          `${MANAGE_FEE_ROUTES.SUMMARY}/:feeId?`,
          `${MANAGE_FEE_ROUTES.SUMMARY}/:flow(edit|save)/:feeId?`,
        ]}
        component={SummaryContainer}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          MANAGE_FEE_ROUTES.CALCULATION,
          `${MANAGE_FEE_ROUTES.CALCULATION}/:feeId?`,
          // `${MANAGE_FEE_ROUTES.CALCULATION}/:flow(edit)/:feeId?`,
          `${MANAGE_FEE_ROUTES.CALCULATION}/:flow(add|edit|save)/:feeId?`,
        ]}
        component={CalculationContainer}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          MANAGE_FEE_ROUTES.SCHEDULE_OR_RUN,
          `${MANAGE_FEE_ROUTES.SCHEDULE_OR_RUN}/:feeId?`,
          `${MANAGE_FEE_ROUTES.SCHEDULE_OR_RUN}/:flow(add|edit|save)/:feeId?`,
        ]}
        component={ScheduleRun}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          MANAGE_FEE_ROUTES.FEE_RUN_PARTICIPANT_DETAILS,
          `${MANAGE_FEE_ROUTES.FEE_RUN_PARTICIPANT_DETAILS}/:planId?`,
          `${MANAGE_FEE_ROUTES.FEE_RUN_PARTICIPANT_DETAILS}/:flow(add|edit|save)/:planId?`,
        ]}
        component={FeeRunParticipantDetails}
      />
      <Redirect
        exact
        menu={menu}
        from={ROUTES.FEE}
        to={MANAGE_FEE_ROUTES.MANAGE_FEE}
      />
    </Switch>
  );
};
